(function () {
  const tagsList = [...document.querySelectorAll('.tags .tag')];

  const navigateLink = ({ currentTarget, key, type }) => {
    if (type === 'click' || key === 'Enter') { 
      const { dataset } = currentTarget;

      window.open(dataset.href, '_self');
    }
  }

  tagsList.forEach((tag) => {
    tag.addEventListener('click', navigateLink);
    tag.addEventListener('keydown', navigateLink);
  });
})();
